
angular.module('gallery').controller('galleryCtrl', ['galleryAnalytics', function (galleryAnalytics) { }]);







// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/gallery/galleryController.js